module.exports = __webpack_public_path__ + "assets/img/text3.c5e60100.png";